import React from 'react';
import { ForgeScaffold } from '@tylertech/forge-react';
import AlertWrapper from './components/alert_wrapper';
import type { AssetBrowserProps } from './types';
import { I18n } from 'common/i18n';

import './ForgeAssetBrowserWrapper.scss';

export const ForgeAssetBrowserWrapper = (props: AssetBrowserProps) => {
  // TODO: Maybe we can remove the AlertWrapper in favor of toast

  return (
    <>
      <ForgeScaffold>
        <div slot="header" className="assets-header forge-typography--heading5">
          {I18n.t('shared.asset_browser.header.title')}
        </div>
      </ForgeScaffold>

      <AlertWrapper />
    </>
  );
};

export default ForgeAssetBrowserWrapper;
